import styles from './SideBarGestaoAdmin.module.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MdOutlineDashboard, MdOutlineFastfood, MdPeopleOutline, MdLogout, MdCropFree, MdOutlineChat, MdDeliveryDining, MdPrint, MdReceiptLong, MdLock } from "react-icons/md";
import { VscLayoutMenubar } from "react-icons/vsc";
import { CiSettings } from "react-icons/ci";
import { useEffect, useState } from 'react';
import usePlano from '../../../shared/hooks/usePlano';




function SideBarGestaoAdmin() {
    const location = useLocation();
    const navigate = useNavigate();
    const [mesasOcupadas, setMesasOcupadas] = useState(0);
    const { temRecurso } = usePlano();

    useEffect(() => {
        const buscarOcupacao = async () => {
            try {
                const API_URL = process.env.REACT_APP_API_URL;
                const token = localStorage.getItem("token");
                const response = await fetch(`${API_URL}/mesas`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (response.ok) {
                    const data = await response.json();
                    setMesasOcupadas(data.filter(mesa => mesa.conta_aberta).length);
                }
            } catch (error) {
                console.log("Erro ao buscar ocupação das mesas:", error.message);
            }
        };

        buscarOcupacao();
    }, []);

    const handleLogout = () => {
        // Limpar todo o localStorage
        localStorage.clear();

        // Redirecionar para a página de login
        navigate('/');
    };

    const menuItems = [
        { path: "/admin/gestaoestabelecimento", label: "Visão Geral", icon: <MdOutlineDashboard /> },
        { path: "/admin/gerenciamentopedidos", label: "Pedidos", icon: <VscLayoutMenubar /> },
        { path: "/admin/gerenciamentocardapio", label: "Cardápio", icon: <MdOutlineFastfood /> },
        { path: "/cadastromesas", label: "Mesas", icon: <MdCropFree /> },
        { path: "/admin/equipe", label: "Equipe", icon: <MdPeopleOutline /> },
        { path: "/admin/whatsapp", label: "WhatsApp", icon: <MdOutlineChat /> },
        { path: "/admin/taxas-entrega", label: "Taxa de Entrega", icon: <MdDeliveryDining /> },
        { path: "/admin/impressao", label: "Impressão", icon: <MdPrint /> },
        { path: "/admin/fiscal", label: "Fiscal", icon: <MdReceiptLong />, recurso: "fiscal" },
        { path: "/admin/configuracoes", label: "Configurações", icon: <CiSettings />}
    ];

    return (
        <aside className={styles.sidebar}>
            <header className={styles.headerSideBar}>
                <div className={styles.marca}>
                    <span className={styles.wordmark}>Speed<span>Order</span></span>
                    <span className={styles.subtitulo}>Gestão de Pedidos</span>
                </div>
            </header>

            <nav>
                <ul className={styles.menuList}>
                    {menuItems.map(item => {
                        const bloqueado = item.recurso && !temRecurso(item.recurso);
                        if (bloqueado) {
                            return (
                                <li key={item.path} className={`${styles.menuItem} ${styles.bloqueado}`}>
                                    <span className={styles.menuLink} aria-disabled="true" title="Disponível no plano Full Speed">
                                        <span className={styles.icon}>{item.icon}</span>
                                        {item.label}
                                        <MdLock className={styles.cadeado} />
                                    </span>
                                </li>
                            );
                        }
                        return (
                        <li
                            key={item.path}
                            className={`${styles.menuItem} ${location.pathname === item.path ? styles.active : ""}`}
                        >
                            <Link to={item.path} className={styles.menuLink}>
                                <span className={styles.icon}>{item.icon}</span>
                                {item.label}
                                {item.path === "/cadastromesas" && mesasOcupadas > 0 && (
                                    <span className={styles.badgeOcupadas}>{mesasOcupadas} ocupada{mesasOcupadas === 1 ? '' : 's'}</span>
                                )}
                            </Link>
                        </li>
                        );
                    })}
                </ul>
            </nav>

            {/* Botão de Logout */}
            <div className={styles.logoutContainer}>
                <button onClick={handleLogout} className={styles.logoutButton}>
                    <MdLogout className={styles.logoutIcon} />
                    <span>Sair da Conta</span>
                </button>
            </div>
        </aside>
    );
}

export default SideBarGestaoAdmin;
